<template>
	<page>
		<c-tab-list ref="tabList" class="factory-tab" :tabs="tabList" :immediate="false" type="border-tab" @change="tabHandle"></c-tab-list>
		
		<div class="factory" :class="{'flex-grow': currentTab != 1}">
			<div v-if="currentTab==1">
				<div class="flex-center-cross">
					<div class="factory-logo">
						<div class="flex-center factory-logo-image">
							<img v-if="dataInfo.saas_logo" :src="dataInfo.saas_logo">
							<a v-else class="factory-logo-add flex-center" @click="editLogoHandle()">
								<i class="tf-plus"></i>
							</a>
							<div v-if="dataInfo.saas_logo && auth('b_factory_name')" class="factory-logo-handle flex-center">
								<a @click="editLogoHandle()"><i class="tf">&#xe618;</i></a>
								<a @click="editLogoHandle(true)"><i class="tf-trash"></i></a>
							</div>
						</div>
						<p class="factory-logo-name flex-center">
							<span>公司LOGO</span>
							<c-tooltip tip="建议尺寸：360X88像素"></c-tooltip>
						</p>
					</div>
					<div>
						<div class="flex-center-cross factory-name">
							<template v-if="editName !== false">
								<input v-model="editName" maxlength="14">
								<c-button color="main" @click="editNameHandle">确定</c-button>
								<c-button @click="editName = false">取消</c-button>
							</template>
							<template v-else>
								<p>{{dataInfo.saas_name}}</p>
								<a v-if="auth('b_factory_name')" @click="editName = dataInfo.saas_name"><i class="tf">&#xe618;</i></a>
							</template>
						</div>

					</div>
				</div>
			</div>

			<div v-if="currentTab==2">
				<c-form unit-width="100%" ref="systemConfigForm" >
					<c-title>单据审批</c-title>
					<c-form-item label="自动审批" tip="开启后，自动完成审批">
						<c-radio-group v-model="auto_approval" name="auto_approval" :options="openCloseDic" :disabled="!auth('b_factory_system_edit')"></c-radio-group>
					</c-form-item>

					<div class="factory-handle flex">
						<c-button v-if="auth('b_factory_system_edit')" size="form" color="main" hollow @click="submitSystemConfig">保存配置</c-button>
					</div>
				</c-form>
			</div>

			<div v-if="currentTab==3" class="flex">
				<c-form class="flex-grow" unit-width="100%" ref="noticeConfigForm" style="max-width: 750px;">
					<c-title>工单开始通知</c-title>
					
					<c-form-item label="状态" tip="开启后，工单开始时会通知拥有管理员">
						<div class="flex-center-cross">
							<c-radio-group v-model="work_start_notice" name="work_start_notice" :options="openCloseDic" :disabled="!auth('b_factory_notice_edit')"></c-radio-group>
						</div>
					</c-form-item>

					<c-title>工单逾期通知</c-title>

					<c-form-item label="状态">
						<div class="flex-center-cross">
							<c-radio-group v-model="work_overdue_notice" name="work_overdue_notice" :options="openCloseDic" :disabled="!auth('b_factory_notice_edit')"></c-radio-group>
						</div>
					</c-form-item>

					<c-form-item v-for="(item, i) in work_overdue_notice_time_list" :key="`w${i}`" v-show="work_overdue_notice==1" :label="'第'+(i+1)+'次通知'" width="300" required>
						<c-input type="stepper" v-model="work_overdue_notice_time_list[i]" decimal="0" :range="[0,99]" step="1" step-controls="side" prepend-text="前" append-text="小时" :disabled="!auth('b_factory_notice_edit')" required></c-input>
						<template #handle v-if="work_overdue_notice_time_list.length > 1 && auth('b_factory_notice_edit')">
							<a class="notice-delete" @click="work_overdue_notice_time_list.splice(i, 1)"><i class="tf-trash"></i></a>
						</template>
					</c-form-item>

					<c-form-item  v-if="auth('b_factory_notice_edit')">
						<c-button size="normal" color="lesser" prepend-icon="tf-plus" hollow style="margin-right: 10px;" @click="addNoticeConfig(1)">添加</c-button>
						<c-tooltip tip="点击添加按钮可以添加一个工单逾期通知配置，设定逾期前几个小时发送通知" position="top"></c-tooltip>
					</c-form-item>


					<div class="factory-handle flex">
						<c-button v-if="auth('b_factory_notice_edit')" size="form" color="main" hollow @click="submitNoticeConfig">保存配置</c-button>
					</div>
				</c-form>
			</div>
		</div>
	</page>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'
	
	export default {
		components: {
		},

		data() {
			return {
				currentTab: 1,
				dataInfo: {},
				editName: false,
				templetList: [],
				currentApplyType: 0,
                auto_approval:0,
                work_start_notice: 0,
                work_overdue_notice: 0,
                work_overdue_notice_time_list: [],
			}
		},

		computed: {
			...mapState(['systemConfig', 'userInfo', 'saasInfo', 'openCloseDic', 'allowDisallowDic']),
			...mapGetters(['freeEdition']),

			tabList() {
				let list = [];
				list.push({"value":1, "name": "基础信息"});
				list.push({"value":2, "name": "系统配置"});
				list.push({"value":3, "name": "通知配置"});
				return list;
			},
		},

		mounted() {
			//默认选中第一个选项卡
			this.$refs.tabList.changeIndex(0);
			this.update();
			//查询系统配置
			this.getSystemConfig();

			if (this.saasInfo.use_template_state == 2) {
				this.showTemplet();
			}
		},

		methods: {
			update() {
				this.request({
					url: '/sys_saas/detail',
					success: data => {
						this.dataInfo = data;
					},
					fail: (code, data, msg) => {
						if (code == 9200) {
							this.$confirm({
								message: msg,
								buttonName: '我知道了',
								cancelButton: false,
								resolve: () => {
									this.$store.commit('setSession', '');
									this.navigateTo('/login');
								}
							})
							return false;
						}
					}
				});
			},

			tabHandle(tab) {
				this.currentTab = tab.value;
			},

			editLogoHandle(remove) {
				new Promise(async resolve => {
					if (remove) {
						if (await this.$confirm({
							message: '确定要删除公司LOGO吗？'
						}) == 'resolve') {
							resolve('');
						}
					} else {
						this.$upload({
							type: 'image',
							loading: true,
							success: data => {
								resolve(data[0].path);
							}
						});
					}
				}).then(data => {
					this.request({
						url: '/sys_saas/edit/logo',
						data: {
							saas_logo: data
						},
						loading: true,
						success: () => {
							this.$message({
								message: '修改成功'
							});
							this.dataInfo.saas_logo = data;
							this.$store.dispatch('updateLoginInfo');
						}
					});
				})
			},

			editNameHandle() {
				if (!this.editName.trim()) {
					this.$message({
						message: '公司名称不能为空'
					});
					return;
				}
				this.request({
					url: '/sys_saas/edit/name',
					data: {
						saas_name: this.editName.trim()
					},
					loading: true,
					success: () => {
						this.$message({
							message: '修改成功'
						});
						this.dataInfo.saas_name = this.editName.trim();
						this.editName = false;
						this.$store.dispatch('updateLoginInfo');
					}
				});
			},

			showTemplet() {
				this.request({
					url: '/sys_saas/templateList',
					loading: true,
					success: data => {
						this.templetList = data.map(item => {
							item.template_sub_title = item.template_sub_title ? item.template_sub_title.split('\n') : [];
							return item;
						});
						this.$refs.templetList.open();
					}
				});
			},
			/****查询系统配置信息*****/
			getSystemConfig(){
				this.request({
					url: '/sys_saas/get/sys/config',
					success: data => {
						data.forEach(item => {

						});
					}
				});
			},
			/**
			 * 添加通知配置
			 * @type 1= 工单通知
			 *       2= 任务通知
			 */
			addNoticeConfig(type){
				if (type == 1){
					this.work_overdue_notice_time_list.push(0);
				}
			},
			/**
			 * 保存系统配置
			 */
			submitSystemConfig() {
				this.$refs.systemConfigForm.submit({
					url: '/sys_saas/set/sys/config',
					rule: {
					},
					dataFormatter: data => {
						var system_config_list = [];
						var obj0 = {
							config_item_name:'自动审批',
							config_item_code:'auto_approval',
							config_item_type:7,
							config_item_value:this.auto_approval||0,
							config_item_remark: '自动审批开关'
						}
						system_config_list.push(obj0);
						return {
							system_config_list:system_config_list
						};
					},
					success: () => {
						this.$message({
							message: '配置成功'
						});
                        //更新全局配置
                        this.$store.dispatch('updateSystemConfig');  // 更新配置
					}
				});
			},
			
			/**
			 * 保存通知配置
			 */
			submitNoticeConfig() {
				var submitFlag = true;
				if (this.work_overdue_notice == 1){
					if(this.work_overdue_notice_time_list.length == 0){
						submitFlag = false;
						this.$message({
							message: '请添加工单逾期通知时间配置',
							type: 'warn'
						});
					}
					let uniqueArr = this.work_overdue_notice_time_list.filter((value, index, self) => {
						return self.indexOf(value) === index;
					});
					if (uniqueArr.length != this.work_overdue_notice_time_list.length){
						submitFlag = false;
						this.$message({
							message: '【工单逾期通知】两次通知的时间不允许相同',
							type: 'warn'
						});
					}
				}
				if (submitFlag){
					this.$refs.noticeConfigForm.submit({
						url: '/sys_saas/set/sys/config',
						rule: {
						},
						dataFormatter: data => {
							data.work_overdue_notice = this.work_overdue_notice||0;
							//排序，数字大的排前面
							this.work_overdue_notice_time_list.sort(function(a, b){return b-a});
							data.work_overdue_notice_time = this.work_overdue_notice==0?'0':this.work_overdue_notice_time_list.join(",");
							return this.handleSubmitData(data);
						},
						success: () => {
							this.$message({
								message: '配置成功'
							});
							//更新全局配置
							this.$store.dispatch('updateSystemConfig');  // 更新配置
						}
					});
				}
			},
			//构造提交数据
			handleSubmitData(data){
				/***********拼装最终的返回数据********/
				var system_config_list = [];
				
				var obj1 = {
					config_item_name:'是否开启【工单开始】通知',
					config_item_code:'work_start_notice',
					config_item_type:7,
					config_item_value:this.work_start_notice,
					config_item_remark: '开启后，工单开始时会通知拥有工单第一道工序报工权限的管理员'
				}
				var obj2 = {
					config_item_name:'是否开启【工单逾期】通知',
					config_item_code:'work_overdue_notice',
					config_item_type:7,
					config_item_value:this.work_overdue_notice,
					config_item_remark: '工单逾期前将按设置的频率发送通知'
				}
				var obj3 = {
					config_item_name:'【工单逾期】通知时间',
					config_item_code:'work_overdue_notice_time',
					config_item_type:1,
					config_item_value:data.work_overdue_notice_time,
					config_item_remark:'表示逾期前几小时通知，多个时间表示通知多次，多个时间之间以英文逗号分隔'
				}
				
				system_config_list.push(obj1);
				system_config_list.push(obj2);
				system_config_list.push(obj3);
				return {
					system_config_list:system_config_list
				};
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.factory {
		border: 1px solid var(--unit-line);
		border-radius: 0 10px 10px 10px;
		border-top: none;
		padding: 26px;
		margin: 0 15px 15px;
		overflow: auto;
		background: #fff;

		&-tab {
			margin: 0 15px;

			>>> ul {
				padding-left: 0;
			}
		}

		&-logo {
			margin-right: 28px;

			&-image {
				position: relative;
				width: 100px;
				height: 100px;
				font-size: 24px;
				color: #ccc;
				background: #32373E;

				&:hover {
					color: var(--color-main);

					.factory-logo-handle {
						display: flex;
					}
				}
			}

			&-add {
				position: absolute;
				inset: 0;
			}

			&-handle {
				gap: 20px;
				display: none;
				position: absolute;
				inset: 0;
				font-size: 20px;
				color: #fff;
				background: rgba(0,0,0,.6);

				a {
					font-size: 20px;

					&:hover {
						color: var(--color-main);
					}
				}
			}

			&-name {
				gap: 5px;
				margin-top: 10px;
				font-size: 13px;
				color: #666;
			}
		}

		&-name {
			height: 32px;
			gap: 12px;

			p {
				font-size: 22px;
				font-weight: bold;
			}

			a {
				font-size: 20px;
				color: var(--color-main);
			}

			input {
				box-sizing: border-box;
				width: 200px;
				height: 100%;
				border: 1px solid #ccc;
				padding: 0 10px;

				&:focus {
					border-color: var(--color-main);
				}
			}

			>>> .c-button {
				height: 32px !important;
			}
		}

		&-code {
			display: inline-block;
			border: 1px solid #ddd;
			border-radius: 15px;
			padding: 0 16px;
			margin-top: 10px;
			line-height: 28px;
			font-size: 14px;
		}

		&-info {
			margin-top: 34px;

			td {
				height: 36px;
				font-size: 14px;

				&:nth-child(1) {
					color: #666;
				}

				&:nth-child(2) {
					padding-left: 20px;
				}

				.edition {
					border-radius: 4px;
					padding: 0 8px;
					margin-right: 10px;
					line-height: 24px;
					font-size: 13px;
					color: #fff;
					background: #F5F5F5;
				}

				.tag {
					border-radius: 4px;
					padding: 0 12px;
					margin: 0 10px;
					line-height: 26px;
					font-size: 15px;
					font-weight: bold;
					background: #F5F5F5;

					span {
						color: var(--color-main);
					}
				}
			}
		}

		&-handle {
			gap: 20px;
			margin-top: 20px;
			
			>>> .c-button {
				border-radius: 4px;
			}
		}
	}

	.templet-list {
		gap: 20px;
		box-sizing: border-box;
		padding: 20px;

		.item {
			width: 300px;
			border-radius: 6px;
			overflow: hidden;
			background: #F9F9F9;
			transition: box-shadow .3s ease;

			&:hover {
				box-shadow: 0 0 10px 2px rgba(0,0,0,.1);
			}

			.cover {
				height: 200px;
				overflow: hidden;

				.image {
					height: 100%;
					background-size: cover;
					background-position: center;
					transition: transform .3s ease;

					^[-2]:hover ^[-2..-1] {
						transform: scale(1.2);
					}
				}
			}

			.info {
				padding: 6px 25px 0;

				h5 {
					line-height: 50px;
					font-size: 18px;
				}

				ul {
					li {
						position: relative;
						padding: 6px 0 6px 24px;
						line-height: 20px;
						font-size: 14px;
						color: #666;

						.tf {
							position: absolute;
							left: 0;
							top: 0;
							line-height: 32px;
							font-size: 15px;
							color: var(--color-main);
						}
					}
				}
			}

			.button {
				padding: 16px 0 20px;

				>>> .c-button {
					width: 108px;
					height: 36px !important;
				}
			}
		}
	}

	.data-type {
		gap: 15px;
		padding: 20px;

		li {
			position: relative;
			border: 1px solid #F5F5F5;
			border-radius: 4px;
			padding: 20px;
			background: #F5F5F5;
			cursor: pointer;

			h5 {
				margin-bottom: 14px;
				font-size: 16px;
				font-weight: normal;
			}

			p {
				line-height: 22px;
			}

			&.z-crt,
			&:hover {
				border-color: var(--color-main);
				background: #fff;
			}

			&.z-crt {
				&:before {
					content: '';
					position: absolute;
					right: 0;
					top: 0;
					border-top: 24px solid var(--color-main);
					border-left: 28px solid rgba(0,0,0,0);
				}

				&:after {
					content: '\e63f';
					position: absolute;
					right: 2px;
					top: 2px;
					font-family: 'iconfont';
					font-size: 10px;
					color: #fff;
				}
			}
		}
	}

	.notice {
		&-delete {
			padding: 5px;
			font-size: 15px;
			color: #f00;

			&:hover {
				border-radius: 4px;
				background: #F5F5F5;
			}
		}

		&-temp {
			height: 520px;

			&-tip {
				margin-left: 20px;
			}
		}

		&-guide {
			align-self: flex-start;
			position: sticky;
			top: 0;
			padding: 26px 30px 20px;
			background: #FAFAFA;

			&-tip {
				margin-bottom: 12px;
				font-size: 13px;
				color: #f55;
			}

			&-arrow {
				position: relative;
				width: 60px;
				height: 1px;
				margin: 90px 16px 0;
				background: #999;

				&:after {
					content: '';
					position: absolute;
					right: 0;
					top: -5px;
					border-left: 10px solid #999;
					border-top: 5px solid rgba(0,0,0,0);
					border-bottom: 5px solid rgba(0,0,0,0);
				}
			}

			&-item {
				width: 180px;

				img {
					height: 180px;
				}

				p {
					margin: 14px 0 10px;
					font-size: 14px;
					font-weight: bold;
					white-space: nowrap;
					color: #f55;
				}

				span {
					line-height: 20px;
					font-size: 13px;
					color: #999;
				}
			}
		}
	}
</style>